import { render, staticRenderFns } from "./PMessages.vue?vue&type=template&id=38b2a677&"
import script from "./PMessages.vue?vue&type=script&lang=js&"
export * from "./PMessages.vue?vue&type=script&lang=js&"
import style0 from "./PMessages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports